<template>
  <div class="OrderInformation">
    <h2 class="OrderInformation__title-top">Подробная информация</h2>
    <div class="OrderInformation__info">
      <div
        v-if="response.contractor.type === 'entrepreneur'"
        class="OrderInformation__col"
      >
        <div class="OrderInformation__info-block">
          <app-title-box
            size="small"
            is-tooltip
            tooltip="Юридическое или физическое лицо, на которое оформлена покупка."
            title="Заказчик"
            class="OrderInformation__info-block-title"
          ></app-title-box>
          <p class="OrderInformation__info-block-text">
            {{ response.contractor.name }}
          </p>
          <div
            class="d-flex OrderInformation__info-block-info"
            v-if="response.contractor.inn"
          >
            <span class="OrderInformation__info-block-info-text">
              ИНН {{ response.contractor.inn || 'н/д' }}
            </span>
          </div>
        </div>
      </div>

      <div
        v-else-if="response.contractor.type === 'person'"
        class="OrderInformation__col"
      >
        <div class="OrderInformation__info-block">
          <app-title-box
            size="small"
            is-tooltip
            tooltip="Юридическое или физическое лицо, на которое оформлена покупка."
            title="Заказчик"
            class="OrderInformation__info-block-title"
          ></app-title-box>
          <p class="OrderInformation__info-block-text">
            {{ response.contractor.name }}
          </p>
          <div
            class="d-flex OrderInformation__info-block-info"
            v-if="response.contractor.inn"
          >
            <span class="OrderInformation__info-block-info-text">
              ИНН {{ response.contractor.inn || 'н/д' }}
            </span>
          </div>
        </div>
      </div>

      <div
        v-else-if="response.contractor.type === 'company'"
        class="OrderInformation__col"
      >
        <div class="OrderInformation__info-block">
          <app-title-box
            size="small"
            is-tooltip
            tooltip="Юридическое или физическое лицо, на которое оформлена покупка."
            title="Заказчик"
            class="OrderInformation__info-block-title"
          ></app-title-box>
          <p class="OrderInformation__info-block-info-text">
            {{ response.contractor.name }}
          </p>
          <div
            class="d-flex OrderInformation__info-block-info"
            v-if="response.contractor.inn"
          >
            <span class="OrderInformation__info-block-info-text">
              ИНН {{ response.contractor.inn || 'н/д' }}
            </span>
          </div>
        </div>
      </div>

      <div class="OrderInformation__col" v-if="isSellerTruck">
        <div class="OrderInformation__info-block">
          <app-title-box
            size="small"
            is-tooltip
            tooltip="Адрес, на который оформлена доставка заказа."
            title="Адрес доставки"
            class="OrderInformation__info-block-title"
          ></app-title-box>
          <p class="OrderInformation__info-block-text">
            {{ response.delivery.address || 'Не указан адрес' }}
          </p>
          <!-- <div class="d-flex OrderInformation__info-block-info">
          <span class="OrderInformation__info-block-title">
            г. Москва
          </span>
          <span class="OrderInformation__info-block-title">
            N55.755831°, E37.617673°
          </span>
        </div> -->
        </div>
      </div>

      <div class="OrderInformation__col" v-else-if="isCustomerTruck">
        <div class="OrderInformation__info-block">
          <app-title-box
            size="small"
            is-tooltip
            tooltip="Информация о складе, с которого возможно получить продукцию."
            title="Адрес склада"
            class="OrderInformation__info-block-title"
          ></app-title-box>
          <p class="OrderInformation__info-block-text">
            {{
              response.delivery.address ||
              response.delivery.warehouse ||
              'Нет данных по складу'
            }}
          </p>
          <!-- <div class="d-flex OrderInformation__info-block-info">
            <span class="OrderInformation__info-block-title">
              г. Москва
            </span>
            <span class="OrderInformation__info-block-title">
              N55.755831°, E37.617673°
            </span>
          </div> -->
        </div>
      </div>

      <div class="OrderInformation__col">
        <div class="OrderInformation__info-block disabled">
          <app-title-box
            size="small"
            is-tooltip
            tooltip="Способ оплаты заказа"
            title="Способ оплаты"
            class="OrderInformation__info-block-title"
          ></app-title-box>
          <p class="OrderInformation__info-block-text">Выставить счёт</p>
          <span class="OrderInformation__info-block-info-text">
            Все отправления будут в одном счёте
          </span>
        </div>
      </div>
    </div>

    <h2 class="OrderInformation__title">Состав заказа</h2>
    <app-table-dropdown
      :isHeaderLink="false"
      :response="[0]"
      :clear="true"
      :isDropdown="false"
      route="/"
    >
      <template #header>
        <div class="app-table-dropdown__table-header">
          <span class="app-table-dropdown__table-header-title">Название</span>
          <span
            v-if="!responsive.isSm"
            class="app-table-dropdown__table-header-title"
          >
            Тип нефтепродукта
          </span>
          <span
            v-if="!responsive.isSm"
            class="app-table-dropdown__table-header-title"
          >
            Место отгрузки
          </span>
          <span
            v-if="!responsive.isSm"
            class="app-table-dropdown__table-header-title"
          >
            Плотность
          </span>
          <span
            class="app-table-dropdown__table-header-title OrderInformation__lot-row"
            >Лот</span
          >
          <span class="app-table-dropdown__table-header-title">
            {{ priceText }}
          </span>
        </div>
      </template>

      <template #row-header>
        <div class="app-table-dropdown__row-header-default">
          <div
            class="app-table-dropdown__row-header-default-item app-table-dropdown__row-header-default-item--column offers-table__row-header-item"
          >
            <span class="text-ellipsis">{{ response.product.name }}</span>
            <template v-if="responsive.isSm">
              <div>{{ response.delivery.warehouse || '' }}</div>
            </template>
          </div>
          <div
            v-if="!responsive.isSm"
            class="app-table-dropdown__row-header-default-item"
          >
            <span class="text-ellipsis">{{ response.product.sort }}</span>
          </div>
          <div
            v-if="!responsive.isSm"
            class="app-table-dropdown__row-header-default-item"
          >
            {{ response.delivery.warehouse || '' }}
          </div>
          <div
            v-if="!responsive.isSm"
            class="app-table-dropdown__row-header-default-item app-table-dropdown__light"
          >
            {{
              response.product.density
                ? response.product.density.toFixed(3)
                : 'н/д'
            }}
            г / см3
          </div>
          <div
            class="app-table-dropdown__row-header-default-item OrderInformation__lot-row"
          >
            <span v-if="response.lotId">№{{ response.lotId }}</span>
            <span v-else>н/д</span>
          </div>
          <div
            class="app-table-dropdown__row-header-default-item OrderInformation__price-row"
          >
            <div>
              {{ priceValue | price() }}
              руб. / {{ unit }}
              <span
                class="app-table-dropdown__old-price"
                v-if="response.discount"
                >{{ response.priceWithoutDiscount | price() }} руб.</span
              >
            </div>

            <div v-if="responsive.isSm" class="app-table-dropdown__light">
              {{
                response.product.density
                  ? response.product.density.toFixed(3)
                  : 'н/д'
              }}
              г / см3
            </div>
          </div>
        </div>
      </template>
    </app-table-dropdown>
  </div>
</template>

<script>
import { getDiscountPrice } from '@/helpers';

export default {
  name: 'OrderInformation',
  components: {
    AppTableDropdown: () => import('@/components/common/AppTableDropdown'),
    AppTitleBox: () => import('@/components/common/AppTitleBox'),
  },
  inject: ['responsive'],
  props: {
    response: {
      type: Object,
      require: true,
    },
    isSellerTruck: {
      type: Boolean,
    },
    isCustomerTruck: {
      type: Boolean,
    },
    unit: {
      type: String,
      default: '',
    },
  },
  computed: {
    priceText() {
      if (this.isCustomerTruck) {
        return 'Цена';
      }
      return this.response.delivery?.isPriceFinal
        ? 'Цена с учетом доставки'
        : 'Цена без доставки';
    },
    priceValue() {
      if (this.isCustomerTruck) {
        return this.response.product.pricePerUnit;
      }
      return this.response.delivery?.isPriceFinal
        ? this.response.pricePerUnit
        : this.response.product.pricePerUnit;
    },
  },
  methods: {
    getDiscountPrice,
  },
};
</script>

<style lang="scss" scoped>
.OrderInformation {
  padding: 20px 30px;
  background: #fff;
  box-shadow: $box-shadow-card-1;

  @include media-xxs() {
    padding: 15px;
  }

  &__lot-row {
    width: 40%;
  }

  &__title {
    @include h-reset;

    margin-bottom: 20px;
    font-size: rem(18);
    font-weight: 300;
    line-height: 22px;
    color: $black;

    @include media-xxs() {
      font-size: rem(16);
    }
  }

  &__title-top {
    @include h-reset;

    display: none;
    margin-top: 0;
    margin-bottom: 20px;
    font-size: rem(18);
    font-weight: 300;
    line-height: 22px;
    color: $black;

    @include media-xxs() {
      display: flex;
    }
  }

  &__price-row {
    @include media-sm() {
      align-self: flex-start;
    }
  }

  &__col {
    display: flex;
    align-items: stretch;
    justify-content: center;

    @include col(4, 15px);
    @include col-md(4, 15px);
    @include col-md(4, 15px);
    @include col-xxs(12, 15px);
  }
  // info
  &__info {
    display: flex;
    flex-wrap: wrap;
    max-width: 1000px;
    margin-right: -7.5px;
    margin-bottom: 30px;
    margin-left: -7.5px;

    @include media-xxs() {
      margin-bottom: 10px;
    }
  }

  &__info-block {
    width: 100%;
    min-height: 80px;
    padding: 7px 12px;
    margin-bottom: 10px;
    border: 1px solid #e0e0e0;
    border-radius: 2px;

    &.disabled {
      background: #f3f3f3;
    }
  }

  &__info-block-title {
    display: flex;
    align-items: center;
    margin: 0 0 5px;
  }

  &__info-block-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__info-block-info-text {
    font-size: rem(13);
    font-weight: 250;
    line-height: 24px;
    color: $gray-dark;
    letter-spacing: 0.02em;
  }

  &__info-block-text {
    margin: 0;
    font-size: rem(14);
    font-weight: 250;
    line-height: 24px;
    color: $black;
    letter-spacing: 0.02em;
  }
}
</style>
